import { useQuery } from "@tanstack/react-query";
import { getHomeworkSharingSettings } from "../../../api/endpoints/HomeworkEndpoints";

export default function useGetHomeworkSharingSettings(homeworkId: string) {
  return useQuery({
    queryKey: ["homework-sharing-settings", homeworkId],
    queryFn: () => getHomeworkSharingSettings(homeworkId),
  });
}
